<template>
  <div style="border-radius: 4px; overflow: auto">
    <v-dialog
      v-if="!summaryMode"
      max-width="500"
      v-model="add_condition_dialog">
      <AddCondition
        :did="item.did || null"
        v-if="add_condition_dialog"
        v-on:close="CloseAddConditionDialog"
        :item="item"
        :itemtype="itemtype"
        v-on:addedcondition="emit('addedcondition')"
        :play_conditions="play_conditions" />
    </v-dialog>
    <div
      v-if="
        itemtype !== 'template' && itemtype !== 'queue_template' && !summaryMode
      ">
      <v-alert
        type="info"
        dense
        variant="tonal"
        text
        style="margin-right: 0px !important; margin-left: 0px !important"
        v-if="item_conditions?.play_conditions?.length === 0 && item.enabled">
        Note: No play conditions set - as this item is enabled it will always
        automatically play.
      </v-alert>
      <v-alert
        type="info"
        dense
        variant="tonal"
        text
        style="margin-right: 0px !important; margin-left: 0px !important"
        v-else-if="
          item_conditions?.play_conditions?.length === 0 && !item.enabled
        ">
        Note: No play conditions set - as this item is disabled it will never
        automatically play.
      </v-alert>
    </div>
    <div
      v-if="!summaryMode"
      class="mb-2"
      style="display: flex; justify-content: space-between; align-content: end">
      <v-spacer />

      <v-btn
        class="mb-2"
        @click="OpenAddConditionDialog()"
        block
        variant="tonal"
        :loading="add_loading">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <div
      v-for="(play_condition, index) in item_conditions.play_conditions"
      :key="(play_condition, index)">
      <v-card
        v-if="play_condition"
        :class="summaryMode ? 'elevation-4 mb-1' : 'mb-2'"
        :style="summaryMode ? 'border-radius: 8px; opacity: 0.95' : ''"
        style="
          background: var(--v-cardColor-base);
          border-radius: 4px;
          padding-top: 10px;
          overflow-y: auto;
          height: unset !important;
          max-height: unset !important;
        "
        flat>
        <v-card-title style="display: flex">
          <v-icon class="mr-2">
            {{ deluge.all_conditions?.[play_condition.script]?.icon }}
          </v-icon>
          <div>
            <div>
              {{ deluge.all_conditions?.[play_condition.script]?.name }}
            </div>
            <div style="opacity: 0.6; font-size: 14px">
              {{ deluge.all_conditions?.[play_condition.script]?.description }}
            </div>
          </div>
          <v-spacer />
          <v-btn
            v-if="!summaryMode"
            dark
            variant="flat"
            @click="DeleteCondition(play_condition, index)"
            small
            :loading="delete_loading[index]"
            class="mr-2"
            style="background-color: var(--inner-background)">
            <v-icon>mdi-trash-can</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card
            style="background: unset !important"
            class="mb-2 pt-1"
            flat>
            <div
              style="display: flex"
              v-if="
                (props.condition_status &&
                  Object.keys(props.condition_status).length > 0) ||
                state.sceneConditionState
              ">
              <div v-for="(val, key) in getConditionStatus(play_condition)">
                <v-card
                  v-if="val.type"
                  :class="summaryMode ? 'ma-1 pa-1 px-1' : 'ma-2 pa-1 px-2'"
                  width="160"
                  height="55"
                  style="
                    background: var(--v-backgroundOffWhite-base) !important;
                  "
                  flat>
                  <div
                    v-if="val.type === 'progress'"
                    style="
                      display: flex;
                      justify-content: start;
                      flex-direction: column;
                      align-items: center;
                      height: 100%;
                      color: #ccc;
                    ">
                    <div>{{ key }}</div>
                    <div
                      style="height: 50px; width: 100%; align-items: center"
                      class="pa-1">
                      <v-progress-linear
                        style="
                          background-color: #393a38;
                          height: 20px;
                          border-radius: 0px;
                          color: white;
                          font-size: 14px;
                          overflow: hidden;
                          border-radius: 5px;
                          font-family: 'Montserrat' !important;
                          font-weight: bolder;
                        "
                        :size="20"
                        height="100%"
                        :width="10"
                        v-model="val.value"
                        color="primary">
                        {{ val.display_value }}
                      </v-progress-linear>
                    </div>
                  </div>
                  <div
                    v-if="val.type === 'trigger'"
                    style="
                      display: flex;
                      justify-content: start;
                      flex-direction: column;
                      align-items: center;
                      height: 100%;
                      color: #ccc;
                    ">
                    <div>{{ key }}</div>
                    <div
                      style="height: 100%; width: 100%; align-items: center"
                      class="pa-1">
                      <v-btn
                        style="
                          border-radius: 6px;
                          height: 20px !important;
                          margin-top: -5px !important;
                        "
                        height="100%"
                        :width="15"
                        @click="
                          ConditionButton(
                            play_condition.uid,
                            item.did,
                            val.func
                          )
                        "
                        color="primary">
                        <v-icon>{{ val.icon }}</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: start;
                      flex-direction: column;
                      align-items: center;
                      height: 100%;
                      color: #ccc;
                    "
                    v-else-if="val.type === 'check'">
                    <div>
                      {{ key }}
                    </div>
                    <v-icon
                      style="height: 100%"
                      color="green"
                      large
                      v-if="val.value">
                      mdi-check-circle
                    </v-icon>
                    <v-icon
                      color="red"
                      style="height: 100%"
                      large
                      v-else>
                      mdi-close-circle
                    </v-icon>
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: start;
                      flex-direction: column;
                      align-items: center;
                      height: 100%;
                      color: #ccc;
                    "
                    v-else-if="val.type === 'text'">
                    <div>{{ key }}</div>
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        height: 100%;
                        font-size: 18px;
                        font-weight: bold;
                        font-family: 'Montserrat', sans-serif;
                      ">
                      <v-icon
                        v-if="val.icon"
                        size="18"
                        style="opacity: 0.7">
                        {{ val.icon }}
                      </v-icon>
                      {{ val.value }}
                    </div>
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: start;
                      flex-direction: column;
                      align-items: center;
                      height: 100%;
                      color: #ccc;
                    "
                    v-else-if="val.type !== 'progress'">
                    <div>
                      {{ key }}
                    </div>
                    <div>{{ val.value }}</div>
                  </div>
                </v-card>
              </div>
            </div>
            <!-- display conditions -->
            <div
              :class="summaryMode ? 'pa-1' : 'pa-3'"
              v-for="(item, i) in play_condition.data"
              :key="(item, i)">
              <div v-if="!item.hidden">
                <div v-if="item.dynamic">
                  <div
                    style="display: flex"
                    class="condition-container">
                    <v-select
                      v-model="item.value"
                      bg-color="var(--v-backgroundOffWhite-base) !important"
                      color="var(--text) !important"
                      v-on:keyup="UpdateTemplateData(item)"
                      v-on:keyup.enter="NewOrUpdateScene()"
                      style="width: 50%"
                      @change="UpdateTemplateData(item)"
                      class="condition-item"
                      :items="['Asset Duration']"
                      label="Dynamic Options"></v-select>
                  </div>
                </div>
                <v-autocomplete
                  v-on:keyup="UpdateTemplateData"
                  v-on:keyup.enter="NewOrUpdateScene()"
                  bg-color="var(--v-backgroundOffWhite-base) !important"
                  filled
                  dense
                  auto-select-first
                  style="height: 66px"
                  v-else-if="item.type == 'asset'"
                  v-model="item.value"
                  :items="GetAssets(item)"
                  item-title="name"
                  item-value="uid"
                  :label="item.label"></v-autocomplete>
                <div v-else-if="item.type == 'color'">
                  <v-card flat>
                    <v-card-subtitle>{{ item.label }}</v-card-subtitle>
                    <div style="display: flex; justify-content: center">
                      <v-color-picker
                        class="ma-2"
                        dot-size="30"
                        rgba
                        hide-mode-switch
                        v-model="item.value"></v-color-picker>
                    </div>
                  </v-card>
                </div>
                <div v-else-if="item.type == 'slider'">
                  <v-card flat>
                    <v-card-subtitle>{{ item.label }}</v-card-subtitle>
                    <v-slider
                      v-on:change="UpdateTemplateData"
                      v-on:keyup.enter="NewOrUpdateScene()"
                      class="pa-3"
                      style="
                        padding-bottom: 0px !important;
                        padding-top: 0px !important;
                      "
                      :max="item.max"
                      :min="item.min"
                      v-model="item.value"></v-slider>
                  </v-card>
                </div>
                <div v-else-if="item.type == 'bool' || item.type == 'trigger'">
                  <v-checkbox
                    @click="UpdateTemplateData"
                    v-on:keyup.enter="NewOrUpdateScene()"
                    dense
                    v-model="item.value"
                    :label="item.label"></v-checkbox>
                </div>
                <div v-else-if="item.type == 'int'">
                  <div
                    v-if="!item.dynamic"
                    style="display: flex"
                    class="condition-container">
                    <v-text-field
                      style="flex-basis: min-content"
                      type="number"
                      class="overflow-input condition-item"
                      v-on:keyup="UpdateTemplateData"
                      v-on:keyup.enter="NewOrUpdateScene()"
                      height="66px"
                      width="50%"
                      dense
                      filled
                      bg-color="var(--v-backgroundOffWhite-base) !important"
                      color="var(--text) !important"
                      v-model.number="item.value"
                      :label="item.label"></v-text-field>
                    <v-spacer />
                  </div>
                </div>
                <div v-else-if="item.type == 'float'">
                  <div
                    v-if="!item.dynamic"
                    style="display: flex"
                    class="condition-container">
                    <v-text-field
                      type="number"
                      class="overflow-input condition-item"
                      v-on:keyup="UpdateTemplateData"
                      v-on:keyup.enter="NewOrUpdateScene()"
                      style="width: 50%"
                      bg-color="var(--v-backgroundOffWhite-base) !important"
                      color="var(--text) !important"
                      v-model="item.value"
                      :label="item.label"></v-text-field>
                  </div>
                </div>
                <div v-else-if="item.type == 'datetime'">
                  <input
                    step="1"
                    v-on:keyup="UpdateTemplateData"
                    v-on:change="UpdateTemplateData"
                    v-on:keyup.enter="NewOrUpdateScene()"
                    type="datetime-local"
                    v-model="item.value" />
                </div>
                <div v-else-if="item.type == 'time'">
                  <input
                    step="3"
                    v-on:keyup="UpdateTemplateData"
                    v-on:change="UpdateTemplateData"
                    v-on:keyup.enter="NewOrUpdateScene()"
                    type="time"
                    v-model="item.value" />
                </div>
                <v-select
                  v-on:keyup="UpdateTemplateData"
                  v-on:keyup.enter="NewOrUpdateScene()"
                  filled
                  @update:modelValue="UpdateTemplateData"
                  v-else-if="item.type == 'day'"
                  dense
                  style="height: 66px"
                  bg-color="var(--v-backgroundOffWhite-base) !important"
                  color="var(--text) !important"
                  v-model="item.value"
                  multiple
                  :items="[
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                    'Sunday',
                  ]"
                  :label="item.label"></v-select>
                <v-select
                  v-on:keyup="UpdateTemplateData"
                  @update:modelValue="UpdateTemplateData"
                  v-on:keyup.enter="NewOrUpdateScene()"
                  filled
                  v-else-if="item.type == 'month'"
                  dense
                  style="height: 66px"
                  bg-color="var(--v-backgroundOffWhite-base) !important"
                  color="var(--text) !important"
                  v-model="item.value"
                  :items="[
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December',
                  ]"
                  :label="item.label"></v-select>
                <v-text-field
                  type="number"
                  v-else-if="item.type == 'year'"
                  min="1900"
                  max="2099"
                  step="1"
                  v-on:keyup="UpdateTemplateData"
                  v-on:keyup.enter="NewOrUpdateScene()"
                  style="height: 66px"
                  dense
                  filled
                  background-color="textBoxBackground"
                  bg-color="var(--v-backgroundOffWhite-base) !important"
                  color="var(--text) !important"
                  v-model="item.value"
                  :label="item.label"></v-text-field>
                <v-autocomplete
                  v-on:keyup="UpdateTemplateData"
                  @update:modelValue="UpdateTemplateData"
                  v-on:keyup.enter="NewOrUpdateScene()"
                  auto-select-first
                  filled
                  v-else-if="item.type == 'enum'"
                  dense
                  style="height: 66px"
                  bg-color="var(--v-backgroundOffWhite-base) !important"
                  color="var(--text) !important"
                  v-model="item.value"
                  :items="getItemsFromDeluge(item.items)"
                  :label="item.label"></v-autocomplete>
                <div v-else-if="item.type == 'datetime_range'">
                  <Datepicker
                    class="date-picker"
                    :dark="state.theme === 'dark'"
                    :text-input="true"
                    :enable-seconds="true"
                    :teleport="false"
                    :multi-calendars="true"
                    :range="true"
                    :auto-apply="true"
                    :utc="true"
                    locale="en-GB"
                    :format="'dd/MM/yyyy HH:mm:ss'"
                    v-model="item.value" />
                </div>
                <div v-else-if="item.type == 'date_range'">
                  <Datepicker
                    class="date-picker"
                    :dark="state.theme === 'dark'"
                    :text-input="true"
                    :enable-seconds="true"
                    :teleport="false"
                    :multi-calendars="true"
                    :range="true"
                    :utc="true"
                    locale="en-GB"
                    :auto-apply="true"
                    :format="'dd/MM/yyyy'"
                    v-model="item.value"
                    :enable-time-picker="false" />
                </div>
                <div v-else-if="item.type == 'time_range'">
                  <div style="display: flex; gap: 16px; align-items: center">
                    <div style="flex-grow: 1">
                      <label
                        class="v-label"
                        style="
                          font-size: 0.875rem;
                          margin-bottom: 4px;
                          display: block;
                        ">
                        Start Time
                      </label>
                      <Datepicker
                        :utc="false"
                        time-picker
                        class="date-picker"
                        :dark="state.theme === 'dark'"
                        :text-input="true"
                        :enable-seconds="true"
                        :teleport="false"
                        :auto-apply="true"
                        locale="en-GB"
                        v-model="(item.value = item.value || [])[0]" />
                    </div>
                    <div style="flex-grow: 1">
                      <label
                        class="v-label"
                        style="
                          font-size: 0.875rem;
                          margin-bottom: 4px;
                          display: block;
                        ">
                        End Time
                      </label>
                      <Datepicker
                        :utc="false"
                        time-picker
                        class="date-picker"
                        :dark="state.theme === 'dark'"
                        :text-input="true"
                        :enable-seconds="true"
                        :teleport="false"
                        :auto-apply="true"
                        locale="en-GB"
                        v-model="(item.value = item.value || [])[1]" />
                    </div>
                  </div>
                  <div
                    class="v-messages__message"
                    style="opacity: 0.6; font-size: 12px; padding-top: 4px">
                    Note: If end time is earlier than start time, it's
                    considered the next day.
                  </div>
                </div>
                <div v-else>
                  <v-text-field
                    v-on:keyup="UpdateTemplateData"
                    v-on:keyup.enter="NewOrUpdateScene()"
                    style="height: 66px"
                    dense
                    filled
                    bg-color="var(--v-fieldColor-base) !important"
                    color="var(--text) !important"
                    v-model="item.value"
                    :label="item.label"></v-text-field>
                </div>
              </div>
            </div>
          </v-card>
        </v-card-text>
      </v-card>
      <!-- conditions display list end -->
    </div>
  </div>
</template>
<script setup>
import AddCondition from './AddCondition.vue';
import { onMounted, ref, watch, defineProps, reactive, onUnmounted } from 'vue';
import { deluge, state } from '@/stores/deluge.js';
import { $http } from '../../stores/http.js';
import { defineAsyncComponent } from 'vue';

// Lazy load the datepicker component and CSS only when needed
const Datepicker = defineAsyncComponent(async () => {
  // Dynamically import CSS
  try {
    await import('@vuepic/vue-datepicker/dist/main.css');
  } catch (e) {
    // Fallback: inject a link tag if dynamic import of CSS fails in this bundler
    const href = '/node_modules/@vuepic/vue-datepicker/dist/main.css';
    if (!document.querySelector(`link[href="${href}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    }
  }
  return (await import('@vuepic/vue-datepicker')).default;
});

const emit = defineEmits([
  'addedcondition',
  'close',
  'NewOrUpdateScene',
  'templateupdate',
  'deletecondition',
]);

const props = defineProps([
  'item',
  'itemtype',
  'summaryMode',
  'condition_status',
]);
const uids = ref([]);
const play_conditions = ref([]);
const conditions_dict = ref({});
const add_condition_dialog = ref(false);
const live_data = ref({});
const item_conditions = ref({ play_conditions: [] });
const delete_loading = ref({});
const add_loading = ref(false);

const itemsCache = ref({});
function getItemsFromDeluge(items) {
  const url = `/deluge_core?keys=${items}`;
  if (items in itemsCache.value) {
    return itemsCache.value[items];
  }
  $http('GET', url).then((data) => {
    const respList = JSON.parse(data).items;
    itemsCache.value[items] = respList;
    return respList;
  });
  return [];
}

watch(
  () => item_conditions,
  () => {
    if (props.item) {
      props.item.conditions = item_conditions.value;
    }
  }
);
watch(
  () => props.item,
  async () => {
    // Skip DID-based condition data for assets (they don't have DIDs)
    if (props.itemtype === 'asset' || props.itemtype === 'asset_variant') {
      return;
    }
    if (props.item.did) {
      await get_condition_data(props.item.did);
    }
  }
);
async function get_condition_data(did) {
  try {
    Object.assign(
      state.sceneConditionState,
      JSON.parse(
        await $http('GET', `/dynamic_engine/condition_data?did=${did}`)
      )
    );
  } catch (e) {
    if (e.response && e.response.status === 404) {
      console.warn('Condition data not found for did:', did);
      // cancel the current task if it was not found
      if (state.sceneConditionSummaryTask) {
        clearInterval(state.sceneConditionSummaryTask);
        state.sceneConditionSummaryTask = null;
      }
      return;
    }
    console.error('Error fetching condition data:', e);
  }
}
onUnmounted(() => {
  state.sceneConditionSummaryModal = null;
});

// Watch for changes to props.item.conditions and update item_conditions
// This is necessary because the parent component may fetch data asynchronously after mount
watch(
  () => props.item?.conditions,
  (newConditions) => {
    if (newConditions) {
      item_conditions.value = newConditions;
    }
  },
  { deep: true, immediate: false }
);

onMounted(async () => {
  // Skip scene condition state for default queue condition configs and assets
  const isDefaultQueueCondition =
    props.itemtype === 'default_nested_queue_condition' ||
    props.itemtype === 'default_standalone_queue_condition';

  const isAsset =
    props.itemtype === 'asset' || props.itemtype === 'asset_variant';

  if (!isDefaultQueueCondition && !isAsset) {
    state.sceneConditionSummaryModal = props.item.did;
  }

  // Initialize item_conditions with fallback for undefined conditions
  item_conditions.value = props.item.conditions || { play_conditions: [] };

  for (const i in item_conditions.value.play_conditions) {
    uids.value.push(item_conditions.value.play_conditions[i]['uid']);
  }

  if (props.itemtype === 'template' || isDefaultQueueCondition || isAsset) {
    return;
  }

  await get_condition_data(props.item.did);
  if (!state.sceneConditionSummaryTask) {
    state.sceneConditionSummaryTask = setInterval(async () => {
      if (state.sceneConditionSummary) {
        await get_condition_data(state.sceneConditionSummary.did);
      } else if (state.sceneConditionSummaryModal) {
        await get_condition_data(state.sceneConditionSummaryModal);
      }
    }, 1000);
  }
});
function ConditionButton(uid, did, function_name) {
  $http(
    'PUT',
    '/dynamic_engine/condition_data_trigger?did=' +
      did +
      '&uid=' +
      uid +
      '&function_name=' +
      function_name
  ).then(() => {
    get_condition_data(props.item.did);
  });
}
function CloseAddConditionDialog() {
  add_condition_dialog.value = false;
}

function OpenAddConditionDialog() {
  add_condition_dialog.value = true;
}

// Helper to get condition status (works for both live and variant conditions)
function getConditionStatus(play_condition) {
  // For asset variants, use the passed condition_status prop
  if (
    props.condition_status &&
    Object.keys(props.condition_status).length > 0
  ) {
    return props.condition_status[play_condition.uid] || {};
  }
  // For live items, use state.sceneConditionState
  if (
    state.sceneConditionState &&
    state.sceneConditionState[play_condition.uid]
  ) {
    return state.sceneConditionState[play_condition.uid];
  }
  return {};
}

function DeleteCondition(play_condition, index) {
  // For default queue conditions, asset variants, and assets - just delete locally (parent will save)
  if (
    props.itemtype === 'default_nested_queue_condition' ||
    props.itemtype === 'default_standalone_queue_condition' ||
    props.itemtype === 'asset_variant' ||
    props.itemtype === 'asset'
  ) {
    // Remove from local copy
    item_conditions.value.play_conditions.splice(index, 1);
    // Also update the original config directly - create a new array to trigger reactivity
    if (props.item.conditions && props.item.conditions.play_conditions) {
      props.item.conditions.play_conditions =
        props.item.conditions.play_conditions.filter((_, i) => i !== index);
    }
    // Emit event so parent can save
    emit('deletecondition');
  } else {
    // Original behavior for live queue/scene instances
    if (props.item.conditions) {
      props.item.conditions.play_conditions =
        props.item.conditions.play_conditions.filter(
          (item) => item != play_condition
        );
    }
    item_conditions.value.play_conditions =
      item_conditions.value.play_conditions.filter(
        (item) => item != play_condition
      );
    props.item.conditions_edited = true;
  }
}
function UpdateTemplateData(item) {
  if (item.dynamic == true) {
    item.value = 'Asset Duration';
  }

  if (item.dynamic == false) {
    item.value = 3;
  }
  props.item.conditions_edited = true;

  emit('templateupdate', item_conditions.value.play_conditions);
}
function NewOrUpdateScene() {
  emit('NewOrUpdateScene', true);
  props.item.conditions_edited = true;
}
</script>
<style scoped>
div {
  overflow: visible !important;
}
</style>
